const setRelativeUrl = (url = '') => {
    return (dispatch) => {
        dispatch({
            type: 'SET_RELATIVE_URL',
            url
        })
    }
}

const setSelectedState = (selectedState = '') => {
    return (dispatch) => {
        dispatch({
            type: 'SET_SELECTED_STATE',
            selectedState
        })
    }
}

const setSelectedMetro = (selectedMetro = '') => {
    return (dispatch) => {
        dispatch({
            type: 'SET_SELECTED_METRO',
            selectedMetro
        })
    }
}

const setSelectedCity = (selectedCity = '') => {
    return (dispatch) => {
        dispatch({
            type: 'SET_SELECTED_CITY',
            selectedCity
        })
    }
}

const resetMobileLocFilters = () => {
    return (dispatch) => {
        dispatch({
            type: 'RESET_MOBILE_LOC_FILTERS'
        })
    }
}

const updateMetros = (metros = []) => {
    return(dispatch) => {
        dispatch({
            type: 'UPDATE_METROS',
            metros
        })
    }
}

const updateCities = (cities =[]) => {
    return(dispatch) => {
        dispatch({
            type: 'UPDATE_CITIES',
            cities
        })
    }
}

export {
    setRelativeUrl, 
    setSelectedState, 
    resetMobileLocFilters, 
    setSelectedMetro, 
    setSelectedCity,
    updateMetros,
    updateCities,
}